import { useNavigate } from "react-router-dom";
import { FaEye } from "react-icons/fa";

export default function CoachTableRow({ coach }) {
  const navigate = useNavigate();

  return (
    <tr className="hover:bg-gray-50 cursor-pointer">
      <td className="px-4 py-2">{coach.fullName}</td>
      <td className="px-4 py-2 text-center">{coach.totalActivities}</td>
      <td className="px-4 py-2 text-center">
        <button
          onClick={() =>
            navigate(`/other-coaches-activities-list/${coach.id}`)
          }
          className="text-blue-600 hover:text-blue-800"
        >
          <FaEye />
        </button>
      </td>
    </tr>
  );
}
